import {
  Box,
  Stack,
  styled,
  Typography,
  Paper,
  Grid,
  IconButton,
  Divider,
  InputAdornment,
} from '@mui/material';
import { Colors, ColorsV2 } from '../../constants/color';

const Container = styled(Box)({
  width: '94.5%',
  marginTop: '64px',
  marginLeft: '10px',
  height: '100%',
  padding: '10px 25px 25px 15px',
});

const SubContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${ColorsV2.white}`,
});

const IconTextStack = styled(Stack)({
  display: 'flex',
  alignItems: 'center',
});

const Text = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: '700',
  fontSize: '1em',
  color: ColorsV2.white,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'uppercase',
});

const ParentPaper = styled(Paper)({
  width: '100%',
  marginTop: '30px',
  borderRadius: '10px',
  border: `1px solid ${Colors.outline}`,
  display: 'flex',
  padding: '30px 50px 25px 30px',
  boxSizing: 'border-box',
  height: '70vh',
});

const CustomIconButton = styled(IconButton)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 'none',
});

const ParentGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0px 30px 0px 0px',
  boxSizing: 'border-box',
});

const SubConatiner3 = styled(Box)({
  width: '100%',
});

const SubTitleText = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  color: Colors.pageHeading_icon,
  marginTop: '15px',
});

const InputContainerStack = styled(Stack)({
  width: '100%',
  marginTop: '1em',
});
const SubTitle = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 700,
  fontSize: '1em',
  color: '#1C1D21',
});
const ChildGrid = styled(Grid)({
  padding: '0 8px',
});
const FormContainer = styled(Box)({
  width: '100%',
  marginTop: '20px',
});

const CustomDivider = styled(Divider)({
  margin: '20px 0',
});

const ImageDiv = styled(Box)({
  height: '35%',
  width: '100%',
  borderRadius: '10px',
  backgroundColor: '#F8FAFB',
  display: 'flex',
  alignItems: 'flex-end',
  padding: '10px 0',
  justifyContent: 'center',
  boxSizing: 'border-box',
});
const CustomAdornment = styled(InputAdornment)({
  fontFamily: 'DM Sans, sans-serif',
  margin: '0px 5px 0px 0px',
  fontSize: '0.7em',
  fontWeight: '400',
  lineHeight: '21px',
});

export {
  ImageDiv,
  CustomDivider,
  FormContainer,
  ChildGrid,
  SubTitle,
  InputContainerStack,
  SubTitleText,
  SubConatiner3,
  ParentGrid,
  CustomIconButton,
  ParentPaper,
  Text,
  IconTextStack,
  SubContainer,
  Container,
  CustomAdornment,
};
